import type { AssetGraphResponseDto } from './external-network.dto';

type AssetGraphEdge = AssetGraphResponseDto['edges'][number];

const toAssetGraphEdgeKey = (edge: AssetGraphEdge): string =>
  `${edge.source}|${edge.target}|${edge.type}`;

export const mergeAssetGraphResponses = (
  base: AssetGraphResponseDto,
  incoming: AssetGraphResponseDto,
): AssetGraphResponseDto => {
  const nodeById = new Map(base.nodes.map((node) => [node.id, node]));

  for (const node of incoming.nodes) {
    nodeById.set(node.id, node);
  }

  const edgeByKey = new Map(
    [...base.edges, ...incoming.edges].map((edge) => {
      const key = toAssetGraphEdgeKey(edge);

      return [key, { ...edge, id: key }];
    }),
  );

  const mergedNodes = [...nodeById.values()];
  const mergedEdges = [...edgeByKey.values()];

  return {
    nodes: mergedNodes,
    edges: mergedEdges,
    truncated: base.truncated || incoming.truncated,
    totalCount: Math.max(
      base.totalCount,
      incoming.totalCount,
      mergedNodes.length,
    ),
  };
};

export const hasNewAssetGraphNodes = ({
  base,
  incoming,
}: {
  base: AssetGraphResponseDto;
  incoming: AssetGraphResponseDto;
}): boolean => {
  const baseNodeIds = new Set(base.nodes.map((node) => node.id));

  return incoming.nodes.some((node) => !baseNodeIds.has(node.id));
};
